import { FiEye, FiGlobe } from 'react-icons/fi';
import {
    IoMdAnalytics,
    IoMdBusiness,
    IoMdColorWand,
    IoMdCube,
    IoMdPricetags,
    IoMdSearch,
    IoMdText,
} from 'react-icons/io';
import { BiLeaf } from 'react-icons/bi';
import { FaHashtag } from 'react-icons/fa';
import { MdOutlineSchool } from 'react-icons/md';

const icons = {
    brand: IoMdBusiness,
    category: IoMdCube,
    product: IoMdPricetags,
    prediction: IoMdColorWand,
    affinity: IoMdSearch,
    trend: IoMdAnalytics,
    keyword: IoMdText,
    watchlist: FiEye,
    spotlight: MdOutlineSchool,
    geo: FiGlobe,
    hashtag: FaHashtag,
    flavor: BiLeaf,
};

function DimensionIcon({ dimensionType, ...props }) {
    const IconComponent = icons[dimensionType];
    return IconComponent ? <IconComponent {...props} /> : null;
}

export default DimensionIcon;
